import React, {useCallback, useEffect, useMemo} from "react";
import * as THREE from "three";
import {useGLTF_fixed_sharedLoad} from "../../../../../../Utils/ThreeJS/3JSHooks.js";
import {observer_mgl_r3} from "../../../../../../Utils/ThreeJS/General.js";
import {Vec3} from "../../../../../../Utils/ThreeJS/VectorStructs.js";

export const AlarmClock = observer_mgl_r3((props: {
	extraProcessing_late?: (scene: THREE.Group)=>void},
)=>{
	const {extraProcessing_late} = props;
	//const {scene} = useGLTF_fixed("/3D/ZUp/AlarmClock_3.0.glb");
	/*const {scene: scene_shared} = LoadGLTF_Fixed_Accessor("/3D/ZUp/AlarmClock_3.0.glb");
	const scene = useMemo(()=>scene_shared?.clone(), [scene_shared]); // Clone the scene to avoid shared state issues*/
	const {scene} = useGLTF_fixed_sharedLoad("/3D/ZUp/AlarmClock_3.0.glb");

	useEffect(()=>{
		if (scene == null) return;
		/*scene.traverse(node=>{
			if (node["isMesh"]) {
				const mesh = node as THREE.Mesh;
				mesh.material = CreateLambertMatFromStandardMat(mesh.material as THREE.MeshStandardMaterial);
			}
		});*/

		scene.visible = false; // Hide clock initially
		scene.scale.set(.01, .01, .01); // Scale down the clock
		extraProcessing_late?.(scene);
	}, [extraProcessing_late, scene]);

	if (scene == null) return;
	return (
		<group position={new Vec3(0, 0, 0).To3JPos()} rotation={[0, 0, 0]}>
			{/*objectsFinal.map((obj, i)=><primitive key={i} object={obj}/>)*/}
			<primitive object={scene}/>
		</group>
	);
});

// temp: for now, instead of showing the scene, create a quad and draw the current "HH:MM" time on it
export const AlarmClock_Simple = observer_mgl_r3((props: {
	extraProcessing_late?: (mesh: THREE.Mesh)=>void},
)=>{
	const {extraProcessing_late} = props;

	const {canvas, ctx} = useMemo(()=>{
		const canvas = document.createElement("canvas");
		canvas.width = 150;
		canvas.height = 50;
		const ctx = canvas.getContext("2d");
		if (!ctx) return {canvas, ctx: null};
		ctx.font = "40px Arial";
		ctx.textAlign = "center";
		ctx.textBaseline = "middle";
		return {canvas, ctx};
	}, []);

	const textMesh = useMemo(()=>{
		const mesh = new THREE.Mesh(
			new THREE.PlaneGeometry(.75, 0.25),
			new THREE.MeshBasicMaterial({
				color: 0xffffff,
				side: THREE.DoubleSide,
				transparent: true,
				opacity: 0.8,
				map: new THREE.CanvasTexture(canvas),
			}),
		);
		mesh.position.set(0, 0, 0.1); // z-up: text sits slightly above the clock (vertical = z); note plane now faces +z (up) instead of the viewer
		//mesh.rotation.x = -Math.PI / 2; // Rotate to face up
		mesh.name = "ClockText";
		mesh.visible = false; // Hide initially
		return mesh;
	}, [canvas]);
	const updateClockText = useCallback(()=>{
		if (!ctx) return;

		ctx.fillStyle = "rgba(0,0,255,1)";
		ctx.fillRect(0, 0, canvas.width, canvas.height);

		/*const now = new Date();
		const hours = String(now.getHours()).padStart(2, "0");
		const minutes = String(now.getMinutes()).padStart(2, "0");
		const text = `${hours}:${minutes}`;*/
		const text = "Lucid?";

		ctx.fillStyle = "rgba(255,255,255,1)";
		ctx.fillText(text, canvas.width / 2, canvas.height / 2);

		textMesh.material.map!.needsUpdate = true; // Mark texture as needing update
	}, [canvas.height, canvas.width, ctx, textMesh.material.map]);
	useEffect(()=>{
		extraProcessing_late?.(textMesh);
		updateClockText(); // Initial update
		/*const interval = setInterval(()=>updateClockText(), 1000); // Update every second
		return ()=>clearInterval(interval);*/
	}, [extraProcessing_late, textMesh, updateClockText]);

	return (
		<group position={new Vec3(0, 0, 0).To3JPos()} rotation={[0, 0, 0]}>
			{/*objectsFinal.map((obj, i)=><primitive key={i} object={obj}/>)*/}
			{/*<primitive object={scene!}/>*/}
			<primitive object={textMesh}/>
		</group>
	);
});